import PageWrapper from "@/components/atoms/PageWrapper"
import { NavigationBarBreadCrumbs } from '@/components/molecules/BackNav'
import { PageTitle } from "@/components/molecules/PageTitle"
import { ProjectHeaderButtons } from "@/components/molecules/ProjectHeaderButtons"
import { Separator } from "@/components/ui/separator"
import { OrganizationTypeWordingResolver } from "@/features/organization/components/atoms/OrganizationTypeWordingResolver"
import { useOrganizationStore, useProjectStore } from "@/lib/zustand/useStore"
import { useEffect } from "react"
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom"

export function RedirectProjectWithLayout() {
    const { orgId, projectId } = useParams();
    /* 
    * Get the last segment of the URL to determine if the user is on the edit page or not
    */
    const location = useLocation();
    const segments = location.pathname.split('/');
    const lastSegmentOfURL = segments[segments.length - 1];
    // const { project, setProject } = useProjectStore()
    const { project } = useProjectStore()

    /* 
    * Fetch project if its null
    */
    // const { data: fetchedProject } = useGetProjectById(projectId)
    // useEffect(() => {
    //     if (!project && fetchedProject) {
    //         setProject(fetchedProject)
    //     }
    // }, [project, setProject, fetchedProject])

    /* 
    * Redirects the user to the correct project or organization page based on the current URL.
    */
    const { organization } = useOrganizationStore()
    const navigate = useNavigate()
    useEffect(() => {
        if (!project) {
            // This code causes unnecessary redirection - the user cannot use the URLs because of it

            // const resolvedPath = `/organization/${orgId}/manage-organization`
            // if (location.pathname !== resolvedPath)
            //     navigate(resolvedPath)
        } else {
            const splitPath = location.pathname.split('/').slice(5)
            const resolvedPath = `/organization/${orgId}/project/${projectId}/${splitPath.join('/')}`
            if (location.pathname !== resolvedPath)
                navigate(resolvedPath)
        }
    }, [organization, project, location, navigate])

    /*
    * Handle Breadcrumbs current page name
    */
    // "edit", "members", "add-survey", "export", "questions", "manage-survey"
    const currentPageBreadCrumbsName = (lastSegmentOfURL: string) => {
        switch (lastSegmentOfURL) {
            case "edit":
                return "Edit";
            case "members":
                return "Members";
            case "add-survey":
                return "Add Survey";
            default:
                return "Information";
        }
    }

    return (

        <PageWrapper className="flex-col">
            <NavigationBarBreadCrumbs.Set
                {
                ...{
                    currentPageName: currentPageBreadCrumbsName(lastSegmentOfURL),
                    pages: [
                        {
                            title: "Home",
                            goTo: `/welcome`
                        },
                        {
                            title: `${organization?.name || "-"}`,
                            goTo: `/organization/${organization?.id}`
                        },
                        {
                            title: <OrganizationTypeWordingResolver capitalize plural />,
                            goTo: `/organization/${orgId}`
                        },
                        {
                            title: project?.name || "Project",
                            goTo: `/organization/${orgId}/project/${projectId}/manage-project`
                        },
                    ]
                }
                }
            />
            <div className="flex flex-col flex-1 w-full gap-2 ">

                <div className="flex items-center justify-between">
                    <PageTitle
                        title={<OrganizationTypeWordingResolver capitalize />}
                        description={project?.name || ""}
                        isArchived={project?.archived || false}
                        archivedIconDescription="Project is archived"
                    />
                    <ProjectHeaderButtons project={project} />
                </div>

                <Separator />

                <Outlet />
            </div >
        </PageWrapper >

    )
}
